var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3, _path4, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path5, _g, _g2, _g3, _path6, _path7, _g4, _path8, _path9, _path10, _path11, _path12, _path13, _rect37, _rect38, _g5, _path14, _rect39, _rect40, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _ellipse, _ellipse2, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _polygon5, _rect41, _path72, _path73, _rect42, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect43, _path85, _ellipse3, _path86, _polygon6, _polygon7, _polygon8, _polygon9, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _polygon10, _path101, _path102, _path103, _path104, _ellipse4, _ellipse5, _path105, _path106, _path107, _path108;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.8,
    y: 604.6,
    width: 860.15,
    height: 0.43,
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 719.79,
    y: 632.28,
    width: 56.98,
    height: 0.43,
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 557.65,
    y: 636.96,
    width: 14.95,
    height: 0.43,
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 636.07,
    y: 616.32,
    width: 82.01,
    height: 0.43,
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.05,
    y: 619.21,
    width: 40.74,
    height: 0.43,
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 149.1,
    y: 619.21,
    width: 44.47,
    height: 0.43,
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 228.97,
    y: 626.47,
    width: 111.2,
    height: 0.43,
    fill: "#ebebeb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.52,527.88H78.34a9.82,9.82,0,0,1-9.8-9.82V51.11a9.81,9.81,0,0,1,9.8-9.73H410.52a9.82,9.82,0,0,1,9.82,9.82h0V518.06A9.82,9.82,0,0,1,410.52,527.88ZM78.34,41.72A9.39,9.39,0,0,0,69,51.11V518.06a9.39,9.39,0,0,0,9.37,9.39H410.52a9.41,9.41,0,0,0,9.39-9.39V51.11a9.41,9.41,0,0,0-9.39-9.39Z",
    fill: "#ebebeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M782.64,527.88H450.44a9.84,9.84,0,0,1-9.82-9.82V51.11a9.83,9.83,0,0,1,9.82-9.73h332.2a9.8,9.8,0,0,1,9.78,9.73V518.06A9.82,9.82,0,0,1,782.64,527.88ZM450.44,41.72a9.41,9.41,0,0,0-9.39,9.39V518.06a9.41,9.41,0,0,0,9.39,9.39h332.2a9.41,9.41,0,0,0,9.39-9.39V51.11a9.41,9.41,0,0,0-9.39-9.39Z",
    fill: "#ebebeb"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "280.36 531.47 575.84 22.26 726.16 22.26 430.68 531.47 280.36 531.47",
    fill: "#fafafa"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "71.15 531.47 222.02 271.47 298.78 271.47 147.91 531.47 71.15 531.47",
    fill: "#fafafa"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "584.25 375.51 705 167.42 766.43 167.42 645.68 375.51 584.25 375.51",
    fill: "#fafafa"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "517.85 491.72 517.85 22.26 491.35 22.26 491.35 491.72 56.13 491.72 56.13 604.61 810.78 604.61 810.78 491.72 517.85 491.72",
    fill: "#f0f0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M807.08,222.47H579.57a16.49,16.49,0,0,1-16.19-15L555,97.46a13.77,13.77,0,0,1,12.41-15c.5,0,1-.06,1.49-.06H796.38a16.53,16.53,0,0,1,16.19,15.06l8.41,110a13.75,13.75,0,0,1-12.43,15A12,12,0,0,1,807.08,222.47Z",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M802.2,222.47H574.69a16.51,16.51,0,0,1-16.19-15l-8.4-110a13.77,13.77,0,0,1,12.41-15c.5,0,1-.06,1.49-.06H791.5a16.54,16.54,0,0,1,16.2,15.06l8.4,110a13.76,13.76,0,0,1-12.43,15A12,12,0,0,1,802.2,222.47Z",
    fill: "#f0f0f0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 569.9,
    y: 100.14,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 618.79,
    y: 100.14,
    width: 82.71,
    height: 3.44,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 723.18,
    y: 100.14,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 570.88,
    y: 113.13,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 619.79,
    y: 113.13,
    width: 55.55,
    height: 3.44,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 724.18,
    y: 113.13,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 571.88,
    y: 126.1,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 620.79,
    y: 126.1,
    width: 71.72,
    height: 3.44,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 725.16,
    y: 126.1,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 572.88,
    y: 139.09,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 621.77,
    y: 139.09,
    width: 79.05,
    height: 3.44,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 726.16,
    y: 139.09,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 573.86,
    y: 152.06,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 622.77,
    y: 152.06,
    width: 27.77,
    height: 3.44,
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 152.06,
    width: 19.84,
    height: 3.44,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 727.14,
    y: 152.06,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 574.86,
    y: 165.03,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 623.75,
    y: 165.03,
    width: 82.71,
    height: 3.44,
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 728.14,
    y: 165.03,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 575.84,
    y: 178.02,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 624.75,
    y: 178.02,
    width: 62.57,
    height: 3.44,
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 729.13,
    y: 178.02,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 576.84,
    y: 190.99,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 625.74,
    y: 190.99,
    width: 55.55,
    height: 3.44,
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 691.05,
    y: 190.99,
    width: 17.39,
    height: 3.44,
    fill: "#fff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 730.11,
    y: 190.99,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 577.83,
    y: 203.96,
    width: 36.32,
    height: 3.44,
    fill: "#fff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 626.72,
    y: 203.96,
    width: 76.91,
    height: 3.44,
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 731.11,
    y: 203.96,
    width: 60.74,
    height: 3.44,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M428.73,94.07l-194.68,44-35-3.44a24.94,24.94,0,0,1-17.07-9.4h0l204.08-46.1A77.31,77.31,0,0,1,419.58,79l3,.65a17.51,17.51,0,0,1,9,5.16h0a5.64,5.64,0,0,1-2.89,9.26Z",
    fill: "#EC1C24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.05,
    y: 152.7,
    width: 100.71,
    height: 1.72,
    transform: "translate(-28.75 49.78) rotate(-12.75)",
    fill: "#EC1C24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.19,
    y: 157.27,
    width: 46.19,
    height: 1.72,
    transform: "translate(-30.97 39.05) rotate(-12.75)",
    fill: "#EC1C24"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.85,
    y: 117.73,
    width: 23.1,
    height: 1.72,
    transform: "translate(-22.44 36.34) rotate(-12.75)",
    fill: "#EC1C24"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M431.62,84.73a17.08,17.08,0,0,0-2-1.83L200.52,134.67l33.53,3.44,194.68-44a5.6,5.6,0,0,0,2.89-9.34Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.58,78.91a77.09,77.09,0,0,0-9.18-1.41l-36.13,8.17h0a4.28,4.28,0,0,0,5.1,3.27l.06,0,42.3-9.56Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.02,
    y: 89.44,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-11.15 83.3) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.15,
    y: 91.02,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-11.66 81.7) rotate(-12.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.29,
    y: 92.55,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-12.17 80.35) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.4,
    y: 94.12,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-12.69 78.87) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.51,
    y: 95.67,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-13.19 77.27) rotate(-12.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.66,
    y: 97.19,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-13.71 75.92) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.77,
    y: 98.8,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-14.22 74.32) rotate(-12.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.89,
    y: 100.31,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-14.73 72.96) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.03,
    y: 101.88,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-15.24 71.37) rotate(-12.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.16,
    y: 103.42,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-15.76 70.01) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.26,
    y: 104.99,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-16.26 68.41) rotate(-12.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.38,
    y: 106.55,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-16.78 67.05) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.76,
    y: 108.9,
    width: 3.02,
    height: 4.32,
    rx: 1.19,
    transform: "translate(-17.37 65.4) rotate(-12.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.65,
    y: 109.64,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-17.8 64.09) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.76,
    y: 111.17,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-18.3 62.56) rotate(-12.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.9,
    y: 112.75,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-18.83 61.14) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.01,
    y: 114.33,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-19.33 59.56) rotate(-12.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.12,
    y: 115.87,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-19.84 58.08) rotate(-12.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.26,
    y: 117.41,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-20.37 56.7) rotate(-12.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.39,
    y: 118.95,
    width: 3.01,
    height: 4.3,
    rx: 1.19,
    transform: "translate(-20.86 55.18) rotate(-12.73)",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.46,94.07,177.4,96.43l8.37,27.93,38.95-8.89C211.49,118.46,187.46,94.07,187.46,94.07Z",
    fill: "#EC1C24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.87,129.66h0a11.34,11.34,0,0,0-7.24-2.65l-27.15-.12-12.57,2.84,21.52,5.68Z",
    fill: "#243E59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M365.24,106.47,279,95.32a40.75,40.75,0,0,0-14.31.68l-11.22,2.52,52.23,21.4Z",
    fill: "#243E59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M361.66,108.26l-49.89,25.93a37,37,0,0,1-8.89,3.23l-7.45,1.72,15-19.28Z",
    fill: "#243E59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M220,136.65l14.06,1.42,194.68-44a5.66,5.66,0,0,0,4.43-5.59Z",
    fill: "#243E59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M485.5,247.41,670.59,297A13.22,13.22,0,0,1,680,313.22h0l-66.74,249a13.22,13.22,0,0,1-16.2,9.35h0L411.91,522h0L485.5,247.43Z",
    fill: "#e66a48"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 524.84,
    y: 482.72,
    width: 1,
    height: 81.2,
    transform: "matrix(0.26, -0.97, 0.97, 0.26, -115.09, 897.09)",
    fill: "#fff"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 526.92,
    y: 458.41,
    width: 1,
    height: 109.42,
    transform: "translate(-103.73 891.43) rotate(-75.15)",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.43,523.82a.34.34,0,0,1-.14,0,.49.49,0,0,1-.34-.62l78.29-271.83a.5.5,0,0,1,.62-.34.49.49,0,0,1,.34.62L422.91,523.46A.51.51,0,0,1,422.43,523.82Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M551.6,463.38a42.24,42.24,0,0,1-37-22,45.59,45.59,0,0,1-4.09-33.93c6.36-24,30.29-38.5,53.33-32.39a42.16,42.16,0,0,1,26.26,20.54A46.24,46.24,0,0,1,573.8,457,42.59,42.59,0,0,1,551.6,463.38Zm1.55-86.62c-18,0-34.64,12.59-39.64,31.47a42.52,42.52,0,0,0,3.81,31.65,39,39,0,0,0,52.8,15.68h0c.68-.37,1.35-.76,2-1.17a42.42,42.42,0,0,0,19-25.6h0a42.56,42.56,0,0,0-3.74-31.65,39.19,39.19,0,0,0-24.29-19.09,38.77,38.77,0,0,0-9.88-1.29Z",
    fill: "#fff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 550.71,
    y: 375.33,
    width: 3.11,
    height: 83.94,
    transform: "translate(7.43 844.26) rotate(-75.16)",
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 507.85,
    y: 416.67,
    width: 86.73,
    height: 3.11,
    transform: "translate(5.69 843.85) rotate(-75.15)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M540.77,461.3l-1.55-2.72c11.58-6.31,19.66-12.63,25.38-19.85a49.06,49.06,0,0,0,10-32.26c-.93-10.8-7.18-20.6-12.69-29.24l2.62-1.68c5.7,8.95,12.18,19.09,13.16,30.65a51.53,51.53,0,0,1-10.61,34.47C559.23,450.6,548.3,457.21,540.77,461.3Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M538.83,461c-6.11-8.73-12-18.5-13.85-30.45a51.62,51.62,0,0,1,7.87-35.23c6.55-9.53,18.31-15.71,27.74-20.69l1.45,2.76c-9.12,4.81-20.5,10.8-26.64,19.71a48.94,48.94,0,0,0-7.33,33c1.73,11.33,7.43,20.71,13.32,29.15Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M578.9,403.91a92.2,92.2,0,0,1-54.17-17.65l1.84-2.5a88.93,88.93,0,0,0,64.6,16.13l.44,3.11A88.65,88.65,0,0,1,578.9,403.91Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M577.57,453c-20.57-15.05-44.2-22-64.85-19l-.46-3.11c21.45-3.11,45.94,4.07,67.16,19.6Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M558.54,302.47,555.76,313l-1.35-.37,1.24-4.66-5.33-1.45-1.26,4.69-1.35-.36,2.8-10.5,1.34.36-1.2,4.51,5.4,1.45,1.19-4.52Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M565.74,314.23l-.34,1.3-6.83-1.81,2.78-10.5L568,305l-.34,1.31-5.3-1.41-.85,3.22,4.66,1.26-.34,1.28-4.67-1.25-.9,3.39Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M574.26,315.08l-5-1.34-1.73,2.36-1.4-.36,7.06-9.32,1.32.34,1.56,11.64-1.42-.36Zm-.14-1.34-.67-5.69-3.39,4.67Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M580.19,308.21l1.33.36-2.42,9.2,5.1,1.35-.36,1.31-6.43-1.71Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M588.82,311.89l-3.21-.85.34-1.31,7.77,2.07-.36,1.3-3.22-.85-2.44,9.2-1.34-.36Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M603.28,314.32l-2.8,10.52-1.33-.36,1.24-4.66L595,318.37,593.75,323l-1.35-.36,2.78-10.5,1.35.34L595.34,317l5.39,1.45,1.2-4.51Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M533.47,320.57c-.87,3.31-3.66,4.78-7.2,3.84L524,323.8l-1,3.81-3.7-1,3.85-14.55,6,1.55C532.66,314.6,534.35,317.24,533.47,320.57Zm-3.72-1a2.07,2.07,0,0,0-1.25-2.65h0a1.86,1.86,0,0,0-.48-.1l-2-.55-1.14,4.28,2.06.52a2,2,0,0,0,2.7-1,1.81,1.81,0,0,0,.14-.45Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M541.64,329.54l-5.5-1.45-1.77,2.53-3.75-1,9.61-13,3.62,1,1.89,16.07-3.82-1Zm-.26-3.33-.43-5.1L538,325.32Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M546.24,332.37l2-2.71a7.73,7.73,0,0,0,3.92,2.56c1.55.41,2.25.1,2.44-.61.61-2.31-7.24-2.59-5.81-8,.69-2.59,3.1-4.21,7-3.1A8.88,8.88,0,0,1,560.2,323l-1.94,2.61a7.43,7.43,0,0,0-3.28-2c-1.55-.41-2.25,0-2.45.76-.6,2.22,7.24,2.53,5.81,7.88-.67,2.53-3.11,4.2-7,3.11A9.79,9.79,0,0,1,546.24,332.37Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M558.28,335.57l2-2.72a7.73,7.73,0,0,0,3.92,2.56c1.55.41,2.23.1,2.42-.62.61-2.3-7.24-2.58-5.79-8,.69-2.6,3.11-4.21,7-3.19a9.43,9.43,0,0,1,4.38,2.54l-2,2.75a7.41,7.41,0,0,0-3.31-2.09c-1.55-.4-2.25,0-2.44.77-.59,2.22,7.24,2.53,5.82,7.88-.69,2.53-3.11,4.19-7,3.11A9.81,9.81,0,0,1,558.28,335.57Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M585.05,334.25c-.89,3.29-3.66,4.77-7.22,3.82l-2.25-.59-1,3.81-3.69-1,3.86-14.57,6,1.56C584.24,328.26,585.93,330.92,585.05,334.25Zm-3.64-1a2,2,0,0,0-1.73-2.73l-2-.55-1.12,4.25,2,.54a2.06,2.06,0,0,0,2.72-1.06h0A2.59,2.59,0,0,0,581.41,333.25Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M585.85,336.52a7.5,7.5,0,1,1-.12.43Zm10.74,2.84a3.68,3.68,0,1,0-4.66,3.23,3.84,3.84,0,0,0,4.6-2.88h0a2.25,2.25,0,0,0,.06-.36Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M607,345.75l-2-.53-1,3.87-3.68-1,3.87-14.56,5.94,1.55c3.56.94,5.24,3.59,4.36,6.92a5.07,5.07,0,0,1-3.77,3.92l1.55,5.31-3.95-1Zm2-7.43-2-.54L605.89,342l2,.54a2.21,2.21,0,0,0,1.51-4.15l-.14-.05-.23-.06Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M619.68,341.18l-4-1.06.86-3.26L628.22,340l-.86,3.26-4-1.06-3,11.31-3.68-1Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M542.13,302.52a93.16,93.16,0,0,1-16.75-4.45A94.23,94.23,0,0,1,542.13,302.52Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M540.57,306.68a43.53,43.53,0,0,1-8.27-1.77,45.57,45.57,0,0,1-8-2.53A88.36,88.36,0,0,1,540.57,306.68Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M628.85,325.5a47.15,47.15,0,0,1-8.47-1.81,47.68,47.68,0,0,1-8.28-2.61,90.68,90.68,0,0,1,16.75,4.43Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M627.3,329.68A88.95,88.95,0,0,1,611,325.34,88.09,88.09,0,0,1,627.3,329.68Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M624.64,444.11A12.75,12.75,0,0,1,607.3,449l-.29-.17S613.7,438.25,624.64,444.11Z",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M614.05,459.81a11.14,11.14,0,0,1-15.71-1.17h0l-.19-.22S606.79,451.71,614.05,459.81Z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M602.31,470.44a11.92,11.92,0,0,1-15.82-5.79l-.12-.27S597.24,460,602.31,470.44Z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M599.88,439.88A11.13,11.13,0,0,1,601,455.6l-.18.21S592.88,448.17,599.88,439.88Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M594.61,452.21s3,7.48-5.35,11C589.26,463.24,586.7,455.34,594.61,452.21Z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M623.6,429.51A10.14,10.14,0,0,1,612,437.94l-.24,0S613.85,428.24,623.6,429.51Z",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M611.72,416.34s7.2,5.52,1.17,14.08C612.89,430.42,605.85,424.22,611.72,416.34Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M603.25,428.58a11.7,11.7,0,0,1,6.52,15.2h0l-.15.34S599.18,439.18,603.25,428.58Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M477.16,405a12.74,12.74,0,0,0,12.62,12.87h.33S489.55,405.34,477.16,405Z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M478.61,423.93a11.14,11.14,0,0,0,14.23,6.77l.27-.11S488.88,420.46,478.61,423.93Z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M484.28,439.39a11.89,11.89,0,0,0,16.59,2.82h0l.23-.17S493.84,432.9,484.28,439.39Z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M500.48,414.09a11.16,11.16,0,0,0-8.73,13.15,1.22,1.22,0,0,0,.06.26S502.44,424.75,500.48,414.09Z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M499.22,426.94s-6.22,5-.81,12.22C498.41,439.11,504.55,433.57,499.22,426.94Z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M485.28,392.85a10.1,10.1,0,0,0,5.86,13h0l.25.09S494.36,396.51,485.28,392.85Z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M502.13,387.29s-9,1.22-8,11.65C494.14,398.94,503.32,397.05,502.13,387.29Z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M503.42,402.12a11.69,11.69,0,0,0-13.15,10h0l0,.28S501.69,413.36,503.42,402.12Z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M577.93,468l-.24-1c34.3-8.66,34.7-36.33,34.7-36.61h1C613.39,430.71,613,459.15,577.93,468Z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M504.8,446.85c-25.78-25.7-11.23-48-11.08-48.19l.83.56c-.14.22-14.21,21.83,11,46.92Z",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M385.42,627.28l.16,4.65a46.17,46.17,0,0,0,22.18-1.86l-.37-8.29A101.16,101.16,0,0,1,385.42,627.28Z",
    fill: "#da825e"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M367.94,599.81l-2.53,5.29L358,611l-6.06-11.79.46-14.27,2.64-2S358.94,590,367.94,599.81Z",
    fill: "#da825e"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M458.64,475.89,450,424.08,420.17,361l-61.05-1.75-5.7,11.6s-3.9,6.13-5.39,18.41c0,0-1.38,14.87-1.9,32l-.35,11.84a66.8,66.8,0,0,0,.79,12.23c2.85,17.88,11.65,71,21.95,111l-15.46,22.8s9.92,21.3,25.85,28.75l3.93,19.65s20.47-1.86,29.78-8.07l-4.35-47.77s34.54-41,49.43-68.56C457.7,503.19,461.43,499.47,458.64,475.89Zm-58,32.57s-5-60.18-4.34-76a168.35,168.35,0,0,1,16.13,58.94Z",
    fill: "#243E59"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M384.18,238.24l-4,2.45.52,58.14a115.69,115.69,0,0,1-17.86,52.88L420.43,354l3.86-107.17a15.33,15.33,0,0,1-5.07-3.15H394Z",
    fill: "#fdebdf"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M422.55,227.84S444.07,245.6,450,255.93c0,0,15.41,3.85,20.83,15.41l1.93-6.31s2.1-6.3,5.6-8L478,270.11s0,9.11,7.71,8.76c0,0,10,1.38,16-9.27a34.43,34.43,0,0,1,3.43-5,6.4,6.4,0,0,1,.31-1.14A6.7,6.7,0,0,1,509,260a34.76,34.76,0,0,1,3.25,10.49c.9,6.57.33,15.76-5.53,26.27,0,0-15.59,27.14-19.44,40.45,0,0-7.53,33.62-32.58,19.61,0,0-3.15,56.73,0,80.37,0,0-19.43.18-29.06-5.6,0,0-6.31-51.83-5.26-77.57l3.86-107.17s-6.93-1.85-10.69-11.22A16.81,16.81,0,0,0,422.55,227.84Z",
    fill: "#EC1C24"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M413.6,235.61s2.72,8.63,10.69,11.22c0,0-2.44-11.33-5.68-14.08A14.76,14.76,0,0,1,413.6,235.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M439.91,288.09a.51.51,0,0,1-.31-.11.5.5,0,0,1-.09-.7l12.75-16.55a5.88,5.88,0,0,0,1.25-3.76c-.13-5.26-3.86-10.7-3.9-10.76a.5.5,0,0,1,.13-.69.51.51,0,0,1,.7.12c.16.24,3.93,5.75,4.07,11.31a7,7,0,0,1-1.46,4.4L440.3,287.89A.49.49,0,0,1,439.91,288.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M427.75,404.43a.51.51,0,0,1-.49-.39c-6.31-26.94,3.46-58.86,3.56-59.18,4.06-13.53,15.19-34.14,19.79-42.37a8.69,8.69,0,0,0,.51-7.38c-2.2-5.7-7.26-12.19-7.31-12.26a.5.5,0,1,1,.79-.61c.21.26,5.2,6.66,7.46,12.51a9.7,9.7,0,0,1-.58,8.23c-4.58,8.2-15.67,28.74-19.7,42.18-.1.32-9.8,32-3.54,58.65a.5.5,0,0,1-.38.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M458.42,323.44h-.06a.5.5,0,0,1-.43-.56c1.66-13.16,12.34-51.3,12.45-51.68a.5.5,0,1,1,1,.27c-.1.38-10.76,38.44-12.42,51.53A.5.5,0,0,1,458.42,323.44Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.3,
    cy: 412.53,
    rx: 2.06,
    ry: 3.74,
    fill: "#243E59"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.75,
    cy: 370.45,
    rx: 2.06,
    ry: 3.74,
    fill: "#243E59"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M391.37,225s-13.94-1.16-35.63,23.91c0,0-15.92,2.1-33.91,15.75a248.68,248.68,0,0,1-38.47,23.16S255.44,299.17,266.82,325c0,0,10.75,17.17,29.78,28.12,0,0,6.41,3.93,9.93-2.47L318.31,335s2.28-3.52-4.13-9.31l-2.28-2.07s8.9-5.79,28.34-8.89c0,0,.62,11.58-2.48,30.19,0,0-13.65,80.25.41,86.24l-1,12.83s6.2-2.28,8.48-4.76c0,0,.55-30.76,2.42-49.92a51.19,51.19,0,0,1,5.39-18.41c3.32-6.5,7.81-15.4,9.41-19.14a108,108,0,0,0,17.86-52.88l-.52-58.14,4-2.45S390.36,235.64,391.37,225Z",
    fill: "#EC1C24"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M380.16,240.69s-.84-9.15,10.54-11.84c0,0-1.65,6.79-6.52,9.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M370.38,289.33a.54.54,0,0,1-.37-.16l-19.62-21.24a6.86,6.86,0,0,1-1.05-7.79l6-11.49a.5.5,0,1,1,.89.46l-6,11.49a5.86,5.86,0,0,0,.89,6.65l19.63,21.24a.49.49,0,0,1,0,.7A.51.51,0,0,1,370.38,289.33Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M338.42,422.72h0a.5.5,0,0,1-.48-.52c1.23-33.81,17.86-78.81,18-79.26,9.78-23.23.2-38.21-4.38-43.58a3.74,3.74,0,0,1-.16-4.64l10.5-14.26a.5.5,0,0,1,.81.6l-10.5,14.25a2.74,2.74,0,0,0,.12,3.41c4.69,5.5,14.52,20.87,4.54,44.59-.16.43-16.74,45.28-18,78.93A.5.5,0,0,1,338.42,422.72Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M343.7,285.29a.5.5,0,0,1-.49-.43c-1.83-13.71-9.79-27.6-9.87-27.74a.51.51,0,0,1,.19-.68.5.5,0,0,1,.68.18c.08.14,8.13,14.21,10,28.11a.5.5,0,0,1-.43.56Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M340.23,315.18h-.05a.49.49,0,0,1-.44-.56,68.88,68.88,0,0,0-.57-19.5.5.5,0,0,1,1-.17,69.81,69.81,0,0,1,.57,19.79A.51.51,0,0,1,340.23,315.18Z"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M297.09,345.52,318.78,358s23.21,21.69,21.94,6.23c0,0,3.5-1,4-6.48,0,0,5,.5,3-8,0,0,5.23-4.74-3-6.74,0,0-14.72,0-22.44-6.48l-9.23-6s-4.24-3-7.73.5C305.32,331.06,301.09,334.3,297.09,345.52Z",
    fill: "#da825e"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M478.37,260.92s-5.22,10.78-2.13,18.16A9.19,9.19,0,0,0,487,284.36c6.22-1.56,17.67-6.26,18.2-19.8Z"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "359.26 359.27 420.16 361 420.43 353.99 362.82 351.71 359.26 359.27",
    fill: "#efad71"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 386.94,
    y: 349.82,
    width: 25.69,
    height: 12.6,
    fill: "#efad71"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M371,359.61l-5.79-.18.12-7.37a2.9,2.9,0,0,1,2.89-2.84h0a2.9,2.9,0,0,1,2.88,2.92h0Z",
    fill: "#efad71"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M371,359.61l-5.79-.18.12-7.37a2.9,2.9,0,0,1,2.89-2.84h0a2.9,2.9,0,0,1,2.88,2.92h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 386.94,
    y: 349.82,
    width: 25.69,
    height: 12.6
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M368.52,556.89a.47.47,0,0,1-.28-.09.5.5,0,0,1-.14-.69l32.11-47.93a.5.5,0,0,1,.69-.14.51.51,0,0,1,.14.7l-32.11,47.93A.49.49,0,0,1,368.52,556.89Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M408.27,571.75l-29.36,36.19,3.93,19.65s20.68-1.56,29.78-8.07Z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M409,636.58l-6.52,3.57s-2.17,1.4-2.32-1.24l0-.47a3.73,3.73,0,0,0-3.84-3.44l-10.7.36v-3.42c13.18,2,22.18-1.86,22.18-1.86Z",
    fill: "#fdebdf"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M414,652.25c-7.91,3.88-46.38,3.57-46.38,3.57a2.2,2.2,0,0,1,1.65-2.08,21.58,21.58,0,0,0,7.2-4.42c8.57-8.18,9.14-14,9.14-14l10.71-.36a3.73,3.73,0,0,1,3.84,3.44l0,.48c.15,2.63,2.32,1.24,2.32,1.24l6.52-3.57C409.77,642.17,414,652.25,414,652.25Z",
    fill: "#EC1C24"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M409,659.85l-39.4.78c-3-.31-2-4.81-2-4.81s38.47.31,46.38-3.57C418.77,660.32,409,659.85,409,659.85Z",
    fill: "#243E59"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M349.09,398.55a.5.5,0,0,1-.21-1c17.64-8.09,18.75-22.34,18.75-22.49a.51.51,0,0,1,.54-.46.49.49,0,0,1,.46.53c0,.14-1.12,15-19.33,23.33A.54.54,0,0,1,349.09,398.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M397.89,402.12a.5.5,0,0,1-.5-.5V362.34a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v39.28A.5.5,0,0,1,397.89,402.12Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M397.89,396.47a.5.5,0,0,1-.19-1c8.2-3.39,6.26-32.53,6.24-32.83a.5.5,0,0,1,1-.07c.08,1.23,2,30.16-6.86,33.83A.43.43,0,0,1,397.89,396.47Z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M402.81,263.15a17.38,17.38,0,0,1-2.49-.18c-11.58-1.72-18.08-14.72-18.35-15.28a.51.51,0,0,1,.23-.67.5.5,0,0,1,.67.23c.06.13,6.54,13.09,17.6,14.73,6.87,1,14.08-2.48,21.46-10.38a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.71C415.92,259.5,409.26,263.15,402.81,263.15Z"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M391.54,222.31s0,12.08-7.36,15.92c0,0,3.15,9.8,13.07,14a16.76,16.76,0,0,0,21.68-7.93l.27-.61s-3.21-2.08-5.66-8.21l-11.67-5.79-4.73-.17Z",
    fill: "#da825e"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M413.4,235.13s2.34,5.32,4.31,7.19c0,0-17.65,3.85-22.38-11.73A17.94,17.94,0,0,0,413.4,235.13Z",
    fill: "#ca6137"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 383.74,
    y: 194.86,
    width: 52.54,
    height: 33.1,
    rx: 16.55,
    transform: "translate(135.89 582.44) rotate(-80.82)",
    fill: "#da825e"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M393.84,190.74c-.82-1.17-1.73-3.47.26-6.64a21.51,21.51,0,0,1,19.39-5.7,20.31,20.31,0,0,1,11.88,7.24,14.83,14.83,0,0,0,4.63,4.08s10.58,5.92-2.56,17.13c0,0-.78-7-3.22-8.9,0,0-4.38,4.55-15.92-1.57,0,0-1.58,6.3-9.63,10l-2.82,17.49s.18,7.88,6.13,5.6l2.1-2.27,13.66,1.92s0,2.8,1.93,4.21a15.89,15.89,0,0,1-14.39,4.78S390,235.74,391.59,219.2l1.81-12s-1.93,1.23-.7-6l1.62-8.12A3.14,3.14,0,0,0,393.84,190.74Z",
    fill: "#333"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.52,
    cy: 209.59,
    rx: 3.85,
    ry: 5.78,
    transform: "translate(-16.13 33.43) rotate(-4.79)",
    fill: "#da825e"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M408.35,195.14l-.15,0L397,191.46a.5.5,0,1,1,.31-1l11.21,3.65a.51.51,0,0,1,.33.63A.51.51,0,0,1,408.35,195.14Z"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "473.37 160.25 514.89 154.38 530.62 239.31 487.63 245.18 473.37 160.25",
    fill: "#243E59"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "476.1 162.56 490.36 240.77 526.63 235.74 513 157.53 476.1 162.56",
    fill: "#fff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "502.94 219.8 499.16 222.32 504.82 229.87 509.23 229.87 513.84 212.05 509.23 212.05 506.71 224.42 505.24 224.42 502.94 219.8",
    fill: "#EC1C24"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.39 234.84 495.85 216.24 503.92 215.12 504.05 216.11 497.02 217.08 500.19 233.71 517.68 231.13 515.23 214.85 516.22 214.7 518.82 231.97 499.39 234.84",
    fill: "#EC1C24"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M363.73,647.81a4.55,4.55,0,0,0,1.08,3.37,6.58,6.58,0,0,1,1.69,3.28v.2a.69.69,0,0,1-.66.55l-10.54.13a3.11,3.11,0,0,1-2.54-1.31c-1.22-1.78-3.09-5.7-4.08-13.88l-2.48-32.41-2.79-22.19,11.79-5.43s-1.25,24.81,4.43,23.7a2,2,0,0,0,1.21-.8,1.75,1.75,0,0,1,2.6-.36,4.34,4.34,0,0,1,1.45,1.53l.53.9a10.79,10.79,0,0,1,1.45,6.33Z",
    fill: "#EC1C24"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M366.49,654.66a5.65,5.65,0,0,1-3.56,4.88h-10.7s-3.72,0-6.36-13.34c0,0-4.4-44.68-6.7-56.41a2.94,2.94,0,0,1,1.83-3.31l2.39-.93,2.79,22.19,2.48,32.41c1,8.18,2.85,12.1,4.08,13.88a3.08,3.08,0,0,0,2.53,1.31l10.54-.13A.7.7,0,0,0,366.49,654.66Z",
    fill: "#243E59"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M486.45,191.77l-1.73.28-.14.86-1.18.19.92-4.9,1.31-.21,2.42,4.36-1.19.19ZM486,191l-.85-1.61-.29,1.79Z",
    fill: "#EC1C24"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M489.56,188.43a1.64,1.64,0,0,1,.66-.27,1.57,1.57,0,0,1,.86.1,1.68,1.68,0,0,1,.69.56,2.41,2.41,0,0,1,.38,1,2.19,2.19,0,0,1-.06,1,1.56,1.56,0,0,1-.47.76,1.49,1.49,0,0,1-.79.37,1.36,1.36,0,0,1-.7,0,1.16,1.16,0,0,1-.52-.33l.36,2.27-1.12.18-.89-5.43,1.13-.19.08.52A1.41,1.41,0,0,1,489.56,188.43Zm1.1.92a.77.77,0,0,0-.62-.15.79.79,0,0,0-.53.34,1.06,1.06,0,0,0,.22,1.33.74.74,0,0,0,.61.15.76.76,0,0,0,.53-.34A1,1,0,0,0,491,190,.93.93,0,0,0,490.66,189.35Z",
    fill: "#EC1C24"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M494,187.7a1.46,1.46,0,0,1,.65-.26,1.6,1.6,0,0,1,.87.09,1.63,1.63,0,0,1,.69.57,2.17,2.17,0,0,1,.37,1,2.2,2.2,0,0,1-.05,1,1.56,1.56,0,0,1-.47.76,1.53,1.53,0,0,1-.79.37,1.36,1.36,0,0,1-.7-.05,1.26,1.26,0,0,1-.53-.33l.37,2.27-1.12.18-.89-5.43,1.13-.19.08.52A1.21,1.21,0,0,1,494,187.7Zm1.09.92a.78.78,0,0,0-.61-.15.77.77,0,0,0-.53.34,1.07,1.07,0,0,0,.21,1.33.81.81,0,0,0,1.15-.19,1,1,0,0,0,.13-.71A.9.9,0,0,0,495.13,188.62Z",
    fill: "#EC1C24"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M498.56,187a1.29,1.29,0,0,1,.63-.28l.2,1.19-.31.05a1,1,0,0,0-.61.29.81.81,0,0,0-.1.67l.27,1.7-1.12.19-.6-3.68,1.13-.19.1.62A1.46,1.46,0,0,1,498.56,187Z",
    fill: "#EC1C24"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M501,190.06a1.72,1.72,0,0,1-.78-.55,1.9,1.9,0,0,1-.41-1,1.87,1.87,0,0,1,.08-1,1.75,1.75,0,0,1,.58-.78,2.21,2.21,0,0,1,1.95-.32,1.78,1.78,0,0,1,.8.55,2.15,2.15,0,0,1,.32,2,1.7,1.7,0,0,1-.59.78,2.09,2.09,0,0,1-.94.39A2.13,2.13,0,0,1,501,190.06Zm1.37-1.23a1,1,0,0,0,.11-.72.91.91,0,0,0-.33-.64.68.68,0,0,0-.58-.15.7.7,0,0,0-.51.32,1,1,0,0,0-.11.72,1,1,0,0,0,.33.64.66.66,0,0,0,.57.15A.74.74,0,0,0,502.38,188.83Z",
    fill: "#EC1C24"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M506,188.34l.37-2.75,1.2-.2-.7,3.89-1.39.23L503.59,186l1.21-.19Z",
    fill: "#EC1C24"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M511.86,186.86l-2.55.42a.78.78,0,0,0,.31.49.67.67,0,0,0,.5.1.6.6,0,0,0,.53-.45l1.2-.2a1.78,1.78,0,0,1-.22.71,1.74,1.74,0,0,1-.53.55,2,2,0,0,1-.79.3,2,2,0,0,1-1-.08,1.59,1.59,0,0,1-.76-.55,2.19,2.19,0,0,1-.33-2,1.69,1.69,0,0,1,.54-.77,2,2,0,0,1,.94-.39,2.13,2.13,0,0,1,1,.07,1.77,1.77,0,0,1,.76.54,2,2,0,0,1,.39.93C511.84,186.63,511.86,186.75,511.86,186.86Zm-1.23-.44a.62.62,0,0,0-.28-.43.75.75,0,0,0-.52-.09.71.71,0,0,0-.45.24.77.77,0,0,0-.17.51Z",
    fill: "#EC1C24"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M512.26,185.49a1.53,1.53,0,0,1,.47-.75,1.56,1.56,0,0,1,.79-.37,1.46,1.46,0,0,1,.69,0,1.17,1.17,0,0,1,.54.33l-.28-1.71,1.13-.18.79,4.88-1.13.18-.08-.53a1.18,1.18,0,0,1-.39.5,1.54,1.54,0,0,1-.65.27,1.56,1.56,0,0,1-.86-.1,1.67,1.67,0,0,1-.7-.57,2.26,2.26,0,0,1-.37-1A2.08,2.08,0,0,1,512.26,185.49Zm2.36,0a.74.74,0,0,0-.61-.15.81.81,0,0,0-.53.33,1.07,1.07,0,0,0,.22,1.34.74.74,0,0,0,.61.15.79.79,0,0,0,.53-.34.9.9,0,0,0,.12-.7A.93.93,0,0,0,514.62,185.45Z",
    fill: "#EC1C24"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M498.58,194l-.89,4.89-1.41.23-2.4-4.36,1.2-.19,1.72,3.3.58-3.68Z",
    fill: "#EC1C24"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M499.19,194.31a.61.61,0,0,1-.26-.4.57.57,0,0,1,.12-.47.66.66,0,0,1,.45-.25.67.67,0,0,1,.51.09.57.57,0,0,1,.26.41.54.54,0,0,1-.12.46.77.77,0,0,1-1,.16Zm1.14.39.59,3.68-1.12.18-.6-3.68Z",
    fill: "#EC1C24"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M502.36,198a1.46,1.46,0,0,1-.66-.36,1.15,1.15,0,0,1-.35-.6l1.11-.18a.46.46,0,0,0,.23.28.63.63,0,0,0,.41.05.59.59,0,0,0,.31-.13.25.25,0,0,0,.08-.24.23.23,0,0,0-.2-.2,3.67,3.67,0,0,0-.56-.08,5.09,5.09,0,0,1-.69-.09,1.11,1.11,0,0,1-.51-.25.92.92,0,0,1-.29-.57,1,1,0,0,1,.08-.6,1.25,1.25,0,0,1,.45-.5,2,2,0,0,1,.78-.28,1.71,1.71,0,0,1,1.15.16,1.39,1.39,0,0,1,.61.84l-1.05.17a.46.46,0,0,0-.21-.28.62.62,0,0,0-.39,0,.49.49,0,0,0-.29.13.23.23,0,0,0-.08.22.25.25,0,0,0,.21.21,2.6,2.6,0,0,0,.55.08,4.85,4.85,0,0,1,.7.09,1.37,1.37,0,0,1,.51.26,1,1,0,0,1,.3.58,1,1,0,0,1-.09.6,1.19,1.19,0,0,1-.46.49,2.07,2.07,0,0,1-.76.27A2.2,2.2,0,0,1,502.36,198Z",
    fill: "#EC1C24"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M505,194.8a1.68,1.68,0,0,1,.48-.75,1.41,1.41,0,0,1,.78-.36,1.39,1.39,0,0,1,.71,0,1.18,1.18,0,0,1,.52.34l-.08-.52,1.12-.18.6,3.68-1.12.18-.09-.52a1.21,1.21,0,0,1-.39.49,1.4,1.4,0,0,1-.66.27,1.45,1.45,0,0,1-.85-.1,1.74,1.74,0,0,1-.7-.57,2.4,2.4,0,0,1-.37-1A2.21,2.21,0,0,1,505,194.8Zm2.36,0a.82.82,0,0,0-.61-.15.79.79,0,0,0-.53.34.9.9,0,0,0-.12.7.93.93,0,0,0,.34.63.74.74,0,0,0,.61.15.78.78,0,0,0,.53-.33,1,1,0,0,0,.13-.71A.94.94,0,0,0,507.31,194.76Z",
    fill: "#EC1C24"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "476.59 165.28 513.38 159.65 515.52 172 478.82 177.66 476.59 165.28",
    fill: "#EC1C24"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M529.33,232.52l1.29,6.79-43,5.87-5.32-31s6.83-9.41,3.11-17.79c0,0-4.66-7.24-8.69,1.76l-3.14,6.72a6,6,0,0,0-.55,2.29c-.09,2.26-.05,7.1,1.47,10.28a6.42,6.42,0,0,1,.55,1.67c.36,2,.94,6.64-.09,10,0,0-3.46,8.58,1.86,15.27a6.3,6.3,0,0,1,1.4,3.81l.16,8.83L478,270.11s-.12,9.31,7.71,8.75c0,0,8.38,1.88,15.07-7.43a24.81,24.81,0,0,0,1.51-2.4A42.24,42.24,0,0,1,509,260l20.73-18.55s11.33-8.39,1.89-20.55c0,0,4.2-9-3.14-15.92,0,0,5.66-13.42-1.68-18.66,0,0,.2-8.27-4.94-9.74a1.75,1.75,0,0,0-1.29.13c-1,.51-2.42,2.12-1.11,7.09,0,0-5.66.63-4,4.4,0,0,.36,3,6.64,5.54l1.09,6.85s-7.3-5-7.3-1.06c0,0-.63,6.08,6.92,13.21,0,0-5,3.77.63,11.32Z",
    fill: "#da825e"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M526.84,186.76a.45.45,0,0,1-.16,0l-7.34-2.52a.5.5,0,1,1,.32-.94l7.34,2.51a.51.51,0,0,1,.31.64A.49.49,0,0,1,526.84,186.76Z",
    fill: "#ca6137"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M528.52,205.42a.5.5,0,0,1-.34-.13l-4.4-4a.5.5,0,1,1,.67-.74l4.41,4a.5.5,0,0,1-.34.87Z",
    fill: "#ca6137"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M531.67,221.35a.52.52,0,0,1-.37-.16c-2.8-2.93-8.71-8.09-8.77-8.15a.5.5,0,0,1,.65-.75c.06.05,6,5.25,8.85,8.21a.5.5,0,0,1,0,.71A.51.51,0,0,1,531.67,221.35Z",
    fill: "#ca6137"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.04,
    cy: 215.38,
    rx: 1.54,
    ry: 1.96,
    fill: "#333"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.55,
    cy: 217.93,
    rx: 1.54,
    ry: 1.96,
    fill: "#333"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M413.35,227.22h-.16l-2.64-.35a.5.5,0,1,1,.14-1l2.63.35a.21.21,0,0,0,.24-.24l-1.06-8a.5.5,0,0,1,1-.13l1.07,8a1.21,1.21,0,0,1-1.21,1.37Z",
    fill: "#ca6137"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M406.46,229.33l8.91,1.07S409.2,239.19,406.46,229.33Z",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M407.18,211.9a.5.5,0,0,1-.4-.19c-1.7-2.2-4.32-.45-4.43-.37a.5.5,0,0,1-.56-.82c1.2-.84,4-1.78,5.78.58a.49.49,0,0,1-.39.8Z",
    fill: "#333"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M423.09,215.11a.53.53,0,0,1-.4-.19c-1.71-2.22-4.31-.45-4.42-.37a.51.51,0,0,1-.7-.13.5.5,0,0,1,.13-.7c1.2-.83,4-1.78,5.78.58a.51.51,0,0,1-.09.71A.47.47,0,0,1,423.09,215.11Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedVisa);
export default __webpack_public_path__ + "static/media/Approved-Visa.1b138366af11e9f6b15916d529cb0cbd.svg";
export { ForwardRef as ReactComponent };